module.exports = __webpack_public_path__ + "img/icon_mini_info.244a10df.svg";